<style>
  /* not visible */
  .arrow {
    display: none;
    width: 62px;
    border-top: 1px solid #aaa;
    position: absolute;
    top: 0px;
    right: -59px;
    z-index: 1;
    transform: rotate(-35deg);
  }

  .arrow-pointer {
    position: absolute;
    right: -5px;
    top: -20px;
    color: red;
    font-size: 24px;
    display: none;
  }

  .v-card.template-highlight--card {
    display: none;
    @media (min-width: 800px) {
      display: block;
    }
  }

</style>

<template>
  <v-card
    v-if="previewModuleCalloutText"
    class="mx-auto template-highlight--card"
    width="280"
    outlined
    style="position:absolute; right: -200px; top: 70px; text-align: left; background-color: #fff;
    border: 3px solid #889a86; border-radius: 20px; background-color: #f4fff9;"
  >
    <v-list-item>
      <v-list-item-content>
        <v-card-text style="padding: 0 10px 10px;">
          <div class="text-overline mb-2" style="font-weight: bold; line-height: 1.4; display: flex; align-items: center; gap: 10px; font-size: 20px;">
            <v-icon style="margin-left: -4px;">
              {{ previewModule.icon ? previewModule.icon : 'mdi-table' }}
            </v-icon>
            {{ translate(previewModule.nameLong || previewModule.id) }}
          </div>
          <div>
            <div style="line-height: 1.3;">
              {{ previewModuleCalloutText }}
            </div>
          </div>
        </v-card-text>

      </v-list-item-content>
      <div class="arrow">
        <div class="arrow-pointer">&#9679;</div>
      </div>
    </v-list-item>
  </v-card>
</template>

<script>
import Mixin from '@/mixins/mixin';

export default {
  name: 'TemplatePreviewHighlight',
  mixins: [Mixin],
  props: {
    previewModule: {},
  },
  computed: {
    previewModuleCalloutText() {
      return this.$store.state.activeTemplate.copy ? this.$store.state.activeTemplate.copy.sheets_callouts[this.previewModule.id] : '';
    },
  },
};
</script>
